import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "store/auth/selectors";
import { useEffect } from "react";
import { APP_PATH } from "view/routes";

const useRedirect = (redirectPath?: string) => {
  const navigate = useNavigate();
  const { id } = useSelector(selectUser);
  useEffect(() => {
    if (id) {
      navigate(redirectPath || APP_PATH);
    }
  }, [id, navigate]);
};
export default useRedirect;
